/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./icon.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const iconStyle = null;
function Icon(_ref) {
  let {
    children
  } = _ref;
  if (!children) return null;
  return /*#__PURE__*/_jsx("div", {
    className: ax(["_1bsb7vkz _4t3i1tcg _syaz1oju"]),
    children: children
  });
}
const _Icon = element(Icon);
export { _Icon as Icon };